import { Box, Button, Text, Stack, useToast, IconButton } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { authApi } from '../api/namespaces/auth';

interface EmailConfirmationBannerProps {
  email: string;
  isDismissed: boolean;
  setIsDismissed: (isDismissed: boolean) => void;
}

export const EmailConfirmationBanner: React.FC<EmailConfirmationBannerProps> = ({ email, isDismissed, setIsDismissed }) => {
  const toast = useToast();

  if (isDismissed) {
    return null;
  }

  const handleResendConfirmation = async () => {
    try {
      const response = await authApi.resendConfirmation(email);
      if (response.success) {
        toast({
          title: "Confirmation email sent",
          description: "Please check your inbox for the confirmation link",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: response.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch {
      toast({
        title: "Error",
        description: "Failed to resend confirmation email. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box 
      w="100%" 
      bg="yellow.100"
      p={3}
      borderBottom="1px"
      borderColor="yellow.200"
      position="relative"
    >
      <IconButton
        icon={<CloseIcon />}
        aria-label="Dismiss banner"
        size="sm"
        position="absolute"
        right={2}
        variant="ghost"
        colorScheme="yellow"
        onClick={() => setIsDismissed(true)}
      />
      <Stack 
        maxW="container.lg" 
        mx="auto" 
        spacing={{ base: 2, md: 4 }}
        direction={{ base: "column", md: "row" }}
        justify="center"
        align="center"
        textAlign="center"
      >
        <Text color="yellow.800">
          Please confirm your email address
        </Text>
        <Button
          size="sm"
          variant="outline"
          colorScheme="yellow"
          onClick={handleResendConfirmation}
          w={{ base: "auto", md: "auto" }}
        >
          <Text display={{ base: "none", md: "inline" }}>Resend Confirmation</Text>
          <Text display={{ base: "inline", md: "none" }}>Resend</Text>
        </Button>
      </Stack>
    </Box>
  );
};

export default EmailConfirmationBanner;
